import {BaseLanguageModel} from './base-language-model';

export class CountryPtPtLanguage extends BaseLanguageModel {
  AUTH_PASSWORD_PLACEHOLDER: string = 'Palavra-passe';

}
